import {HttpClient, HttpContext} from '@angular/common/http'
import {inject, Service} from '@angular/core'
import {MatSnackBar} from '@angular/material/snack-bar'
import {LatestInterest} from '@sparbanken-syd/kalpylator'
import {DISABLE_AUTH, X_API_KEY} from '@sparbanken-syd/sparbanken-syd-bankid'
import {EMPTY, Observable} from 'rxjs'
import {catchError, map} from 'rxjs/operators'
import {environment} from '../../environments/environment'
import {SECRET} from '../../environments/secret'

@Service()
export class InterestService {
  private readonly snackBar = inject(MatSnackBar)
  private readonly httpClient = inject(HttpClient)

  /**
   * Get the latest valid interest from database
   */
  public getLatestInterest(): Observable<LatestInterest> {
    const url = `${environment.rtUrl}/interests/latest`
    const context = new HttpContext()
      .set(DISABLE_AUTH, true)
      .set(X_API_KEY, SECRET)

    return this.httpClient.get<LatestInterest>(url, {context})
      .pipe(
        catchError(() => {
          this.snackBar.open('Ett fel har inträffat. Den senaste räntan är inte korrekt. Kontrollera din internetanslutning', 'OKEJ', {
            horizontalPosition: 'center',
            verticalPosition: 'top'
          })
          return EMPTY
        }),
        map((interest: LatestInterest) => interest)
      )
  }
}
